import { styled } from 'styled-components';

import { colors } from '#/theme/theme';

export const OrgFieldInfo = styled.div`
  font-size: 14px;
  padding: 13px 22px;
  color: ${colors.mediumContentGrey};
  background-color: ${colors.calloutGrey};
  border-radius: 8px;
`;
